import React from "react";
import { IGatsbyImageData } from "gatsby-plugin-image";
import GatsbyImageTag from "components/partials/parts/gatsby-image-tag";
import IntroHeadline from "./parts/intro-headline";
import { IntroHeadlineProps } from "types/intro-headline-props";

/**
 * suggested image size 1194x676
 */
type FeaturedImageProps = {
    intro?: IntroHeadlineProps;
    image?: IGatsbyImageData;
    alt?: string;
};

const FeaturedImage: React.FC<FeaturedImageProps> = ({ intro, image, alt }) => {

    return (
        <div className="pattern">
            <div className="container container--md">
                {intro &&
                    <IntroHeadline {...intro} />
                }
                {image && <GatsbyImageTag image={image} alt={alt} />}
            </div>
        </div>
    );
};

export default FeaturedImage;